// extracted by mini-css-extract-plugin
export default {"slideshow-image":"slideshow_slideshow-image__D2Tp6"};